export default "__VITE_ASSET__DybC1Wcz__"